import React from 'react';

const PERIODS = [
  { value: 7, label: '7 dias' },
  { value: 30, label: '30 dias' },
  { value: 90, label: '90 dias' }
];

export function RetentionMetricsTabs({ value, onChange }) {
  return (
    <div className="retention-tabs">
      {PERIODS.map(period => (
        <button
          key={period.value}
          className={`retention-tabs__button ${value === period.value ? 'retention-tabs__button--active' : ''}`}
          onClick={() => onChange(period.value)}
          type="button"
        >
          {period.label}
        </button>
      ))}
    </div>
  );
}
